import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Products } from '../components/Products/Products';

import { inDoor } from '../assets/data/indoor.js';
import { kitchens } from '../assets/data/kitchens';
import { security } from '../assets/data/security';
import { steelWork } from '../assets/data/steelWork';
import { bedrooms } from '../assets/data/bedrooms';

import styles from './ProductsPage.module.css';

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const ProductsPage = () => {
  useEffect(() => {

  }, []);

  let query = useQuery().get('type');
  let targetData = {};

  switch (query) {
    case 'security':
      targetData = security;
      break;
    case 'steel_work':
      targetData = steelWork;
      break;
    case 'kitchens':
      targetData = kitchens;
      break;
    case 'bedrooms':
      targetData = bedrooms;
      break;
  }

  return (
    <div>
      <Header />
      <div className={styles.productPage}>
        <div className="container">
          <Products data={targetData} />
          {query === 'security' && <Products data={inDoor} />}
        </div>
      </div>
      <Footer />
    </div>
  )
}
